function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// Bundled with Packemon: https://packemon.dev
// Platform: browser, Support: stable, Format: esm

import { openDB } from 'idb';
import md5 from 'md5';
import { useRef, useEffect, useCallback } from 'react';

/**
 * Invoke functions that have been listed, in order, passing the result of each function to the next in the list,
 * and then return the final function result as the result of the whole
 * @param {function} that takes an input value and return the same type
 */
function compose(fn1, ...fns) {
  return fns.reduce((prevFn, nextFn) => value => prevFn(nextFn(value)), fn1);
}

/* eslint-disable */

// useful type for recursive structure like json

let AnalyticsQueries = /*#__PURE__*/function (AnalyticsQueries) {
  AnalyticsQueries["fbclid"] = "fbclid";
  AnalyticsQueries["gclid"] = "gclid";
  AnalyticsQueries["msclkid"] = "msclkid";
  AnalyticsQueries["ptclid"] = "ptclid";
  AnalyticsQueries["ttclid"] = "ttclid";
  AnalyticsQueries["utm_source"] = "utm_source";
  AnalyticsQueries["utm_medium"] = "utm_medium";
  AnalyticsQueries["utm_campaign"] = "utm_campaign";
  AnalyticsQueries["utm_term"] = "utm_term";
  AnalyticsQueries["utm_content"] = "utm_content";
  return AnalyticsQueries;
}({});
/**
 * Constants for userTypeEnum - This format protects the leakage of user types into the
 * source of client applications.
 */
const UserTypeRetail = 0;
const UserTypeInsto = 1;
const UserTypeRetailEmployeeInternal = 2;
const UserTypeRetailEmployeePersonal = 3;
const UserTypeRetailBusinessBanking = 4;
const UserTypeCommerce = 5;
const UserTypeWallet = 6;

/**
 * These are explicitly tied to UserTypes above for strict verification
 */

let AnalyticsEventImportance = /*#__PURE__*/function (AnalyticsEventImportance) {
  AnalyticsEventImportance["low"] = "low";
  AnalyticsEventImportance["high"] = "high";
  return AnalyticsEventImportance;
}({});
let MetricType = /*#__PURE__*/function (MetricType) {
  MetricType["count"] = "count";
  MetricType["rate"] = "rate";
  MetricType["gauge"] = "gauge";
  MetricType["distribution"] = "distribution";
  MetricType["histogram"] = "histogram";
  return MetricType;
}({});

// TODO @zizzamia figure out how to use Record<SessionActions, number> here

// TODO @zizzamia figure out how to use Record<SessionActions, number> here

let SubjectType = /*#__PURE__*/function (SubjectType) {
  SubjectType["commerce_merchant"] = "commerce_merchant";
  SubjectType["device"] = "device";
  SubjectType["edp_fingerprint"] = "edp_fingerprint";
  SubjectType["nft"] = "nft";
  SubjectType["user"] = "user";
  SubjectType["wallet"] = "wallet";
  SubjectType["uuid"] = "user_uuid";
  return SubjectType;
}({});
// If you add to this enum, please also update the allowed_component_type variable in https://config.cbhq.net/development/data/analytics-service-development and https://config.cbhq.net/production/data/analytics-service-production
let ComponentType = /*#__PURE__*/function (ComponentType) {
  ComponentType["unknown"] = "unknown";
  ComponentType["banner"] = "banner";
  ComponentType["button"] = "button";
  ComponentType["card"] = "card";
  ComponentType["chart"] = "chart";
  ComponentType["content_script"] = "content_script";
  ComponentType["dropdown"] = "dropdown";
  ComponentType["link"] = "link";
  ComponentType["page"] = "page";
  ComponentType["modal"] = "modal";
  ComponentType["table"] = "table";
  ComponentType["search_bar"] = "search_bar";
  ComponentType["service_worker"] = "service_worker";
  ComponentType["text"] = "text";
  ComponentType["text_input"] = "text_input";
  ComponentType["tray"] = "tray";
  ComponentType["checkbox"] = "checkbox";
  ComponentType["icon"] = "icon";
  return ComponentType;
}({});

// If you add to this enum, please also update the allowed_action_type variable in: https://config.cbhq.net/development/data/analytics-service-development and https://config.cbhq.net/production/data/analytics-service-production
let ActionType = /*#__PURE__*/function (ActionType) {
  ActionType["unknown"] = "unknown";
  ActionType["blur"] = "blur";
  ActionType["click"] = "click";
  ActionType["change"] = "change";
  ActionType["dismiss"] = "dismiss";
  ActionType["focus"] = "focus";
  ActionType["hover"] = "hover";
  ActionType["select"] = "select";
  ActionType["measurement"] = "measurement";
  ActionType["move"] = "move";
  ActionType["process"] = "process";
  ActionType["render"] = "render";
  ActionType["scroll"] = "scroll";
  ActionType["view"] = "view";
  ActionType["search"] = "search";
  ActionType["keyPress"] = "keyPress";
  return ActionType;
}({});

// If you add to this enum, please also update the allowed_platform variable in: https://config.cbhq.net/development/data/analytics-service-development and https://config.cbhq.net/production/data/analytics-service-production
let PlatformName = /*#__PURE__*/function (PlatformName) {
  PlatformName["unknown"] = "unknown";
  PlatformName["web"] = "web";
  PlatformName["android"] = "android";
  PlatformName["ios"] = "ios";
  PlatformName["mobile_web"] = "mobile_web";
  PlatformName["tablet_web"] = "tablet_web";
  PlatformName["server"] = "server";
  PlatformName["windows"] = "windows";
  PlatformName["macos"] = "macos";
  PlatformName["extension"] = "extension";
  return PlatformName;
}({});
let AmplitudePlatformName = /*#__PURE__*/function (AmplitudePlatformName) {
  AmplitudePlatformName["web"] = "Web";
  AmplitudePlatformName["ios"] = "iOS";
  AmplitudePlatformName["android"] = "Android";
  return AmplitudePlatformName;
}({});

/**
 * @deprecated This is no longer required and will be removed in the next major version update (8.0.0)
 */

let AuthStatus = /*#__PURE__*/function (AuthStatus) {
  AuthStatus[AuthStatus["notLoggedIn"] = 0] = "notLoggedIn";
  AuthStatus[AuthStatus["loggedIn"] = 1] = "loggedIn";
  return AuthStatus;
}({});
let SessionActions = /*#__PURE__*/function (SessionActions) {
  SessionActions["ac"] = "ac";
  SessionActions["af"] = "af";
  SessionActions["ah"] = "ah";
  SessionActions["al"] = "al";
  SessionActions["am"] = "am";
  SessionActions["ar"] = "ar";
  SessionActions["as"] = "as";
  return SessionActions;
}({}); // action search
let SessionAutomatedEvents = /*#__PURE__*/function (SessionAutomatedEvents) {
  SessionAutomatedEvents["pv"] = "pv";
  return SessionAutomatedEvents;
}({}); // pageview
let SessionRank = /*#__PURE__*/function (SessionRank) {
  SessionRank["xs"] = "xs";
  SessionRank["s"] = "s";
  SessionRank["m"] = "m";
  SessionRank["l"] = "l";
  SessionRank["xl"] = "xl";
  SessionRank["xxl"] = "xxl";
  return SessionRank;
}({});

// With this trick we can use both ActionType and string

// https://docs.datadoghq.com/tracing/guide/send_traces_to_agent_by_api/#model

/* eslint-enable */

/**
 * Never use API paths or domain directly.
 * Read from config
 */
const DEV_DOMAIN = 'https://analytics-service-dev.cbhq.net';
const PROD_DOMAIN = 'https://as.coinbase.com';
const DEV_INTERNAL_DOMAIN = 'https://analytics-service-internal-dev.cbhq.net';
const PROD_INTERNAL_DOMAIN = 'https://analytics-service-internal.cbhq.net';
const EVENTS_API_PATH = '/amp';
const METRICS_API_PATH = '/metrics';
const EXPOSURE_API_PATH = '/track-exposures';
const TRACES_API_PATH = '/traces';
const ANALYTICS_SDK_VERSION = '9.1.2';
const BATCH_PERIOD = 5 * 1000; // 5s
const BATCH_THRESHOLD = 30;
const DB_ITEM = 'analytics-db';
const DB_NAME = 'keyval-store';
const DEBUG_LOGGING_PREFIX = 'Analytics SDK:';
const MAX_EVENT_DATA_QUEUE_LIMIT = 10;
const SESSION_TIMEOUT = 30 * 60 * 1000; // 30 minutes
// All User Acquisition Queries
const UAA_QUERIES = Object.values(AnalyticsQueries);
const PAGEVIEW_EVENT_TYPE = 'pageview';
const SESSIONS_DURATION_EVENT_TYPE = 'session_duration';
const PERF_EVENTS = {
  navigationTiming: {
    eventName: 'perf_navigation_timing'
  },
  redirectTime: {
    eventName: 'perf_redirect_time'
  },
  RT: {
    eventName: 'perf_redirect_time'
  },
  TTFB: {
    eventName: 'perf_time_to_first_byte'
  },
  networkInformation: {
    eventName: 'perf_network_information'
  },
  storageEstimate: {
    eventName: 'perf_storage_estimate'
  },
  FCP: {
    eventName: 'perf_first_contentful_paint'
  },
  FID: {
    eventName: 'perf_first_input_delay'
  },
  LCP: {
    eventName: 'perf_largest_contentful_paint'
  },
  CLS: {
    eventName: 'perf_cumulative_layout_shift'
  },
  TBT: {
    eventName: 'perf_total_blocking_time'
  },
  NTBT: {
    eventName: 'perf_navigation_total_blocking_time'
  },
  INP: {
    eventName: 'perf_interact_to_next_paint'
  },
  ET: {
    eventName: 'perf_element_timing'
  },
  userJourneyStep: {
    eventName: 'perf_user_journey_step'
  }
};

// Tracing
const DEFAULT_SPAN_PARENT_ID = '1';
const DEFAULT_SPAN_TYPE = 'web';

/* eslint-disable */

/**
 * use this regex to test custom end point
 */
const ENDPOINT_VALIDATION_REGEX = /^(https?:\/\/)/;
const HTTPS_PREFIX = 'https://';
function buildAPIEndPoints(domain) {
  return {
    eventsEndpoint: domain + EVENTS_API_PATH,
    metricsEndPoint: domain + METRICS_API_PATH,
    exposureEndpoint: domain + EXPOSURE_API_PATH,
    tracesEndpoint: domain + TRACES_API_PATH
  };
}

/**
 * Analytics SDK main configuration options
 */
const config = _objectSpread(_objectSpread({
  authCookie: 'logged_in',
  amplitudeApiKey: '',
  batchEventsPeriod: BATCH_PERIOD,
  batchEventsThreshold: BATCH_THRESHOLD,
  batchMetricsPeriod: BATCH_PERIOD,
  batchMetricsThreshold: BATCH_THRESHOLD,
  batchTracesPeriod: BATCH_PERIOD,
  batchTracesThreshold: BATCH_THRESHOLD,
  headers: {},
  interactionManager: null,
  isAlwaysAuthed: false,
  isProd: false,
  isInternalApplication: false,
  onError: (err, metadata) => {
    console.error(DEBUG_LOGGING_PREFIX, err, metadata);
  },
  platform: PlatformName.unknown,
  projectName: '',
  ricTimeoutScheduleEvent: 1000,
  ricTimeoutSetDevice: 500,
  showDebugLogging: false,
  trackUserId: false,
  version: null,
  apiEndpoint: DEV_DOMAIN
}, buildAPIEndPoints(DEV_DOMAIN)), {}, {
  steps: {}
});
const getSecuredEndpoint = properties => {
  if (!properties.apiEndpoint) {
    return properties.isInternalApplication ? PROD_INTERNAL_DOMAIN : PROD_DOMAIN;
  }
  return ENDPOINT_VALIDATION_REGEX.test(properties.apiEndpoint) ? properties.apiEndpoint : `${HTTPS_PREFIX}${properties.apiEndpoint}`;
};
const enhanceApiEndpoint = properties => {
  if (!properties.isProd) {
    if (properties.isInternalApplication) {
      properties.apiEndpoint = DEV_INTERNAL_DOMAIN;
      return _objectSpread(_objectSpread({}, properties), buildAPIEndPoints(properties.apiEndpoint));
    } else {
      return properties;
    }
  }
  const apiEndpoint = getSecuredEndpoint(properties);
  return _objectSpread(_objectSpread({}, properties), {}, {
    apiEndpoint
  }, buildAPIEndPoints(apiEndpoint));
};
const enhanceConfig = compose(enhanceApiEndpoint);
const setConfig = properties => {
  const batchEventsThreshold = properties.batchEventsThreshold,
    batchMetricsThreshold = properties.batchMetricsThreshold,
    batchTracesThreshold = properties.batchTracesThreshold;
  const batchThresholds = [batchEventsThreshold, batchMetricsThreshold, batchTracesThreshold];
  for (const threshhold of batchThresholds) {
    if ((threshhold || 0) > BATCH_THRESHOLD) {
      console.warn(`You are setting the threshhold for the batch limit to be greater than ${BATCH_THRESHOLD}. This may cause request overload.`);
      break;
    }
  }
  Object.assign(config, enhanceConfig(properties));
};

/* eslint-enable */

const Platforms = [PlatformName.web, PlatformName.mobile_web, PlatformName.tablet_web];

// Copy of cds breakpoints
const deviceBreakpoints = {
  phone: 360,
  phoneLandscape: 560,
  tablet: 768,
  tabletLandscape: 1024,
  desktop: 1280,
  desktopLarge: 1440,
  extraWide: 1600
};
function isAndroidPlatform() {
  return config.platform === 'android';
}
function isIOSPlatform() {
  return config.platform === 'ios';
}
function isMobileWeb() {
  const mediaQueryList = window.matchMedia(`(max-width: ${deviceBreakpoints.phoneLandscape}px)`);
  return mediaQueryList.matches;
}
function isTabletWeb() {
  const mediaQueryList = window.matchMedia(`(max-width: ${deviceBreakpoints.tabletLandscape}px, min-width: ${deviceBreakpoints.phoneLandscape + 1}px)`);
  return mediaQueryList.matches;
}
function isWebPlatform() {
  return Platforms.includes(config.platform);
}
function postMessage(message) {
  if (!isWebPlatform()) {
    return;
  }
  if (navigator && 'serviceWorker' in navigator && navigator.serviceWorker.controller) {
    // Could be an edge case when the Browser makes an attempt
    // to send a message to a Service Worker that is no longer usable
    try {
      navigator.serviceWorker.controller.postMessage(message);
    } catch (e) {
      if (e instanceof Error) {
        config.onError(e);
      }
    }
  }
}

/* eslint-disable */

/**
 * Cross-platform device information
 */
const device = {
  // Amplitude legacy log event properties
  amplitudeOSName: null,
  amplitudeOSVersion: null,
  amplitudeDeviceModel: null,
  amplitudePlatform: null,
  // Device information
  browserName: null,
  browserMajor: null,
  osName: null,
  userAgent: null,
  width: null,
  height: null
};

/**
 * Information need it to identify the user experience.
 */
const identity = {
  countryCode: null,
  deviceId: null,
  device_os: null,
  isOptOut: false,
  languageCode: null,
  locale: null,
  jwt: null,
  session_lcc_id: null,
  userId: null
};

/**
 * Returns a random v4 UUID of the form xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx,
 * where each x is replaced with a random hexadecimal digit from 0 to f, and
 * y is replaced with a random hexadecimal digit from 8 to b.
 */
const generateUUID = input => {
  return input ? (input ^ Math.random() * 16 >> input / 4).toString(16) : '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, generateUUID);
};
const getIsAuthed = () => {
  return config.isAlwaysAuthed || !!identity.userId;
};

/**
 * User Properties is a legacy concept from Amplitude
 */
const getUserProperties = () => {
  const userProperties = {};
  // The extra "if" helps Types safe
  if (identity.countryCode) {
    userProperties.country_code = identity.countryCode;
  }
  return userProperties;
};

/**
 * Define platform value based on the Analytics Service standard
 */
const getPlatformValue = () => {
  const platform = config.platform;
  if (platform === PlatformName.web) {
    switch (true) {
      case isMobileWeb():
        return PlatformName.mobile_web;
      case isTabletWeb():
        return PlatformName.tablet_web;
    }
  }
  return platform;
};

/**
 * Set device information based on the platform used
 */
const setDevice = () => {
  if (isWebPlatform()) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(setUAParser, {
        timeout: config.ricTimeoutSetDevice
      });
    } else {
      setUAParser();
    }
    device.amplitudePlatform = AmplitudePlatformName.web;
    device.userAgent = window?.navigator?.userAgent || null;
    setDeviceSize({
      height: window?.innerHeight ?? null,
      width: window?.innerWidth ?? null
    });
  } else if (isIOSPlatform()) {
    device.amplitudePlatform = AmplitudePlatformName.ios;
  } else if (isAndroidPlatform()) {
    device.amplitudePlatform = AmplitudePlatformName.android;
  }
};
const setIdentity = properties => {
  Object.assign(identity, properties);
  if (isWebPlatform()) {
    postMessage({
      identity: {
        isAuthed: !!identity.userId,
        locale: identity.locale || null
      }
    });
  }
};
const setLanguageCode = () => {
  if (isWebPlatform()) {
    identity.languageCode = navigator?.languages[0] || navigator?.language || '';
  }
};
const setDeviceSize = properties => {
  device.height = properties.height;
  device.width = properties.width;
};
const setPlatform = () => {
  setConfig({
    platform: getPlatformValue()
  });
  if (isWebPlatform()) {
    postMessage({
      config: {
        platform: config.platform
      }
    });
  }
};

/**
 * Set device information related to the User Agent
 * TODO @zizzamia move this logic into Analytics Service
 */
const setUAParser = () => {
  if (performance.mark) {
    performance.mark('ua_parser_start');
  }
  const UAParser = require('ua-parser-js');
  const userAgentParser = new UAParser(device.userAgent).getResult();
  device.browserName = userAgentParser.browser.name || null;
  device.browserMajor = userAgentParser.browser.major || null;
  device.osName = userAgentParser.os.name || null;
  device.amplitudeOSName = device.browserName;
  device.amplitudeOSVersion = device.browserMajor;
  device.amplitudeDeviceModel = device.osName;
  // Post Message to Service Worker
  postMessage({
    device: {
      browserName: device.browserName,
      osName: device.osName
    }
  });
  if (performance.mark) {
    performance.mark('ua_parser_end');
    performance.measure('ua_parser', 'ua_parser_start', 'ua_parser_end');
  }
};

/* eslint-enable */

const location = {
  breadcrumbs: [],
  initialUAAData: {},
  pageKey: '',
  // TODO @zizzamia move page_key in the Analytics Service
  pageKeyRegex: {},
  pagePath: '',
  prevPageKey: '',
  prevPagePath: ''
};
function setBreadcrumbs(breadcrumbs) {
  Object.assign(location, {
    breadcrumbs
  });
}
function setLocation(data) {
  Object.assign(location, data);
}
const persistentData = {
  // Legacy Amplitude
  eventId: 0,
  sequenceNumber: 0,
  sessionId: 0,
  // Session definitions
  lastEventTime: 0,
  sessionStart: 0,
  sessionUUID: null,
  userId: null,
  // Session Quality
  // To note these variable are in purpose very short
  // so they are less obvious inside the public IndexedDB
  // and public client events
  ac: 0,
  // action click
  af: 0,
  // action focus
  ah: 0,
  // action hover
  al: 0,
  // action scroll
  am: 0,
  // action move
  ar: 0,
  // action search
  as: 0,
  // action select
  pv: 0 // pageview
};

function setPersistentData(data) {
  Object.assign(persistentData, data);
}
function getDocumentReferrer() {
  return document?.referrer ?? '';
}

/* eslint-disable */

/**
 * Parse the domain from referrer info.
 * It keeps subdomain referres but removes
 * the ones from the same hostname
 */
const getReferrerData = () => {
  const documentReferrer = getDocumentReferrer();
  if (!documentReferrer) {
    return {};
  }
  const referrerURL = new URL(documentReferrer);
  if (referrerURL.hostname === getUrlHostname()) {
    return {};
  }
  return {
    referrer: documentReferrer,
    referring_domain: referrerURL.hostname
  };
};

/**
 * Parse utms and gclid from query and retrieves referrer,
 * to collect user acquisition data
 */
const getUserAcquisitionAttribution = () => {
  if (!isWebPlatform()) {
    return location.initialUAAData;
  }
  // When UAA data exist we return always the initial value
  if (Object.keys(location.initialUAAData).length > 0) {
    return location.initialUAAData;
  }
  new URLSearchParams(getUrlParams());
  // Set prev value to avoid extra calls;
  location.initialUAAData = _objectSpread(_objectSpread(_objectSpread({}, persistentUAAData()), uaaValuesFromUrl()), getReferrerData());
  return location.initialUAAData;
};
const uaaValuesFromUrl = () => {
  const urlSearchParams = new URLSearchParams(getUrlParams());
  const UAAValues = {};
  UAA_QUERIES.forEach(key => {
    if (urlSearchParams.has(key)) {
      UAAValues[key] = (urlSearchParams.get(key) || '').toLowerCase();
    }
  });
  return UAAValues;
};

// Return persisted UAA data from memory
const persistentUAAData = () => {
  const uaaData = {};
  UAA_QUERIES.forEach(key => {
    if (persistentData[key]) {
      uaaData[key] = persistentData[key];
    }
  });
  return uaaData;
};
const getUrlHostname = () => {
  return window?.location?.hostname || '';
};
const getUrlParams = () => {
  return window?.location?.search || '';
};
const getUrlPathname = () => {
  return window?.location?.pathname || '';
};
const getPagePath = () => {
  return config.overrideWindowLocation ? location.pagePath : getUrlPathname() + getUrlParams();
};
const setPageKey = () => {
  if (!location.pageKeyRegex) {
    return;
  }
  Object.keys(location.pageKeyRegex).some(pageKey => {
    if (location.pageKeyRegex[pageKey].test(location.pagePath)) {
      location.pageKey = pageKey;
      return true;
    }
  });
};

/**
 * Sets a new pagePath when the location.pathname or location.search changes.
 * Have unique pagePath based on query params is critical to allow web experiences
 * doing what they do best, have statless content based on the complete web URL.
 */
const setPagePath = () => {
  const pagePath = getPagePath();
  if (!pagePath || pagePath === location.pagePath) {
    return;
  }
  if (pagePath !== location.pagePath) {
    setPrevPagePath();
  }
  location.pagePath = pagePath;
  setPageKey();
};

/**
 * Defines which page was previously visited,
 * and if the users come from the Monorail, we can detect it by its referrer value.
 */
const setPrevPagePath = () => {
  if (isWebPlatform()) {
    const documentReferrer = getDocumentReferrer();
    if (!location.prevPagePath && documentReferrer) {
      const referrerURL = new URL(documentReferrer);
      if (referrerURL.hostname === getUrlHostname()) {
        location.prevPagePath = referrerURL.pathname;
        return;
      }
    }
  }
  location.prevPagePath = location.pagePath;
  location.prevPageKey = location.pageKey;
};
const setUserAttributionEnrichment = validatedEvent => {
  // User Attribution enrichment
  if (isWebPlatform()) {
    Object.assign(validatedEvent, getUserAcquisitionAttribution());
  }
};

/* eslint-enable */

const snakeCaseRegex = /^[a-zd]+(_[a-zd]+)*$/;

/**
 * Tests whether the input value string is acceptable as custom property key.
 * The method validates against a slight modified version of snake case where
 * the value can contain a single lower case word
 * @param {string} value input to test
 * @return {boolean} whether string is valid or not
 */
function isEventKeyFormatValid(value) {
  return snakeCaseRegex.test(value);
}

// This object can be used to store properties which will be used to enhance events

const BLOCKED_PROPS = ['action', 'component_type', 'component_name', 'context', 'logging_id'];

// num_non_hardware_accounts valid values: small | medium | large | x-large
const ALLOWED_PROPERTIES = ['num_non_hardware_accounts', 'ujs'];
const UJS_PREFIX = 'ujs_';

/**
 * Use these object to store properties that will be attached to each event
 * This object is only stored in memory therefore it does not persist across user sessions.
 * If a user reloads the page this info will disappear
 */
const identityFlow = {
  //  this feature is currently in alpha release
  //  in order to add properties you must submit a PR
};

/**
 * Clears identity flow by deleting properties. Delete only properties you have introduced
 * @param {string[]} properties to delete
 * @return {void}
 */
function removeFromIdentifyFlow(properties) {
  properties.forEach(prop => {
    if (ALLOWED_PROPERTIES.includes(prop)) {
      delete identityFlow[prop];
    }
  });
}

/**
 * Appends properties to identify flow
 * @param {EventDataDefault} identityData properties to be added to identify flow. Format for each key is enforced and must be snake_case
 * @return {void}
 */
function identifyFlow(identityData) {
  //  filter for blocked words
  const filteredProps = Object.entries(identityData).reduce((acc, entry) => {
    const _entry = _slicedToArray(entry, 2),
      key = _entry[0],
      value = _entry[1];
    if (!BLOCKED_PROPS.includes(key) && ALLOWED_PROPERTIES.includes(key)) {
      //  check for snake case otherwise error_out
      if (isEventKeyFormatValid(key)) {
        return _objectSpread(_objectSpread({}, acc), {}, {
          [key]: value
        });
      }
      config.onError(new Error(`IdentityFlow property names must have snake case format`), {
        [key]: value
      });
      return acc;
    }
    return acc;
  }, {});
  if (filteredProps.ujs?.length) {
    filteredProps.ujs = filteredProps.ujs.map(value => `${UJS_PREFIX}${value}`);
  }
  Object.assign(identityFlow, filteredProps);
}

/**
 * Enriches validated event data with identity flow properties
 * @param {AnalyticsValidatedData} validatedEvent
 * @return {void}
 */
function setIdentityFlowEnrichment(validatedEvent) {
  if (Object.keys(identityFlow).length > 0) {
    Object.assign(validatedEvent, identityFlow);
  }
}
function isIdentifyFlowEmpty() {
  return !Object.keys(identityFlow).length;
}

/**
 * this method validates if config platofrm is set correctly.
 * If the value is different than PlatformName.unknown returns true
 * otherwise returns false and logs an error
 */
function isValidPlatform() {
  if (config.platform === PlatformName.unknown) {
    config.onError(new Error('SDK platform not initialized'));
    return false;
  }
  return true;
}
const scheduler = {
  eventsQueue: [],
  eventsScheduled: false,
  metricsQueue: [],
  metricsScheduled: false,
  tracesQueue: [],
  tracesScheduled: false
};
function setScheduler(options) {
  Object.assign(scheduler, options);
}

/* eslint-disable */

// Session Quality records all major actions, and those are used
// to rate device sessions objectively and mechanically
// with the Session Quality Score algorithm.
// Note, if you are looking to make any changes to this algorithm
// make sure to reach out to the UI Observability Working Group or @zizzamia.
const sessionQuality = {
  ac: 0,
  // action click
  af: 0,
  // action focus
  ah: 0,
  // action hover
  al: 0,
  // action scroll
  am: 0,
  // action move
  ar: 0,
  // action search
  as: 0,
  // action select
  pv: 0,
  // page view
  sqs: 0 // session quality score
};

/**
 * The Session Quality Score algorithm takes into consideration
 * all the actions performed during a session. Each action has a weight
 * that goes from 0 to N, and it is always an integer.
 * Each action's weight reflects the importance of the performed action.
 */
const ACTIONS_WEIGHT = {
  ac: 20,
  // action click
  af: 5,
  // action focus
  ah: 1,
  // action hover
  al: 1,
  // action scroll
  am: 0,
  // action move
  ar: 10,
  // action search
  as: 20 // action select
};

const SESSION_AUTOMATED_EVENTS_WEIGHT = {
  pv: 25 // pageview
};

/**
 * Each session gets a rank based on how long it lasts, measured in seconds
 */
const SESSION_DURATION_RANK = {
  xs: 0,
  s: 15,
  m: 60,
  l: 240,
  xl: 960,
  xxl: 3840
};

/**
 * The Session Quality Score algorithm muliplies the final score
 * based on the weight of the session_duration.
 */
const SESSION_DURATION_WEIGHT = {
  xs: 0,
  // Anything less than 15s resets the SQS to 0
  s: 1,
  // From 16s to 4 minutes the SQS doesn't change
  m: 1,
  l: 2,
  // Anything longer than 4 minutes will double the SQS
  xl: 2,
  xxl: 2
};
const getSessionRank = sessionDuration => {
  if (sessionDuration < SESSION_DURATION_RANK.s) {
    return SessionRank.xs;
  }
  if (sessionDuration < SESSION_DURATION_RANK.m) {
    return SessionRank.s;
  }
  if (sessionDuration < SESSION_DURATION_RANK.l) {
    return SessionRank.m;
  }
  if (sessionDuration < SESSION_DURATION_RANK.xl) {
    return SessionRank.l;
  }
  if (sessionDuration < SESSION_DURATION_RANK.xxl) {
    return SessionRank.xl;
  }
  return SessionRank.xxl;
};

/**
 * Based on each valid event, the action value is read to determine
 * what session quality properties need to be updated.
 *
 * Note: these variables are very short on purpose so they are less
 * obvious within the public IndexedDB and public client events.
 */
const recordSessionAction = validatedEvent => {
  switch (validatedEvent.action) {
    case ActionType.click:
      sessionQuality.ac += 1;
      break;
    case ActionType.focus:
      sessionQuality.af += 1;
      break;
    case ActionType.hover:
      sessionQuality.ah += 1;
      break;
    case ActionType.move:
      sessionQuality.am += 1;
      break;
    case ActionType.scroll:
      sessionQuality.al += 1;
      break;
    case ActionType.search:
      sessionQuality.ar += 1;
      break;
    case ActionType.select:
      sessionQuality.as += 1;
      break;
  }
};
const setSessionQuality = properties => {
  Object.assign(sessionQuality, properties);
};

/**
 * Session Quality Score algorithm
 * -------------------------------
 * Rating device sessions objectively and mechanically
 */
const setSessionQualityScore = validatedEvent => {
  if (!validatedEvent.session_rank) {
    return;
  }
  const sessionRank = validatedEvent.session_rank;
  // Each action weight reflects the importance of the performed actions
  Object.values(SessionActions).forEach(action => {
    sessionQuality.sqs += sessionQuality[action] * ACTIONS_WEIGHT[action];
  });
  // Each sessionautomated event reflects a boost in engagement
  Object.values(SessionAutomatedEvents).forEach(sessionAutomatedEvent => {
    sessionQuality.sqs += sessionQuality[sessionAutomatedEvent] * SESSION_AUTOMATED_EVENTS_WEIGHT[sessionAutomatedEvent];
  });
  // Muliplies the final score based on the weight of the session_duration
  sessionQuality.sqs *= SESSION_DURATION_WEIGHT[sessionRank];
};
const setSessionQualityEnrichment = validatedEvent => {
  recordSessionAction(validatedEvent);
  // Counts pageviews
  if (validatedEvent.event_type === PAGEVIEW_EVENT_TYPE) {
    sessionQuality.pv += 1;
    return;
  }
  if (validatedEvent.event_type !== SESSIONS_DURATION_EVENT_TYPE) {
    return;
  }
  setSessionQualityScore(validatedEvent);
  // Enriches sessionQuality into `session_duration` event
  Object.assign(validatedEvent, sessionQuality);
  // Resets action counts
  setSessionQuality({
    ac: 0,
    af: 0,
    ah: 0,
    al: 0,
    am: 0,
    ar: 0,
    as: 0,
    pv: 0,
    sqs: 0
  });
};

/* eslint-enable */

// Gets the time value in milliseconds
function getNow() {
  return new Date().getTime();
}

/**
 * The TimeStone will hold the power to understand the past, present and future
 * of the user experience. In a few words we are getting a little smarter
 * on understanding how much time a user is spending for each pagePath, pageKey and session.
 *
 * Also for not colliding with any default naming system,
 * I decided to call this timeStone in honor of Doctor Strange.
 */
const timeStone = {
  timeStart: getNow(),
  timeOnPagePath: 0,
  timeOnPageKey: 0,
  prevTimeOnPagePath: 0,
  prevTimeOnPageKey: 0,
  // TODO @zizzamia re-visit if we need to keep storing
  // sessionDuration and sessionEnd here, it seems we don't
  // need to persist this information.
  sessionDuration: 0,
  sessionEnd: 0,
  sessionStart: 0,
  prevSessionDuration: 0
};
function setTime(data) {
  Object.assign(timeStone, data);
}
const db = {
  isReady: false,
  idbKeyval: null
};
function setDB(properties) {
  Object.assign(db, properties);
}

/* eslint-disable */

// This is a temporary IndexedDB fallback for React Native.
// We are going to consider more elaborate solutions soon.
const reactNativeDB = {};
const initIDB = () => {
  if (isWebPlatform() && window?.indexedDB) {
    const dbPromise = openDB(DB_NAME, 1, {
      upgrade(idbDB) {
        idbDB.createObjectStore('keyval');
      }
    });
    setDB({
      idbKeyval: {
        async get(key) {
          return (await dbPromise).get('keyval', key);
        },
        async set(key, val) {
          return (await dbPromise).put('keyval', val, key);
        },
        async delete(key) {
          return (await dbPromise).delete('keyval', key);
        },
        async keys() {
          return (await dbPromise).getAllKeys('keyval');
        }
      }
    });
  } else {
    // Fallback IDB when IndexedDB is not supported
    setDB({
      idbKeyval: {
        async get(key) {
          return new Promise(resolve => {
            resolve(reactNativeDB[key]);
          });
        },
        async set(key, val) {
          return new Promise(resolve => {
            reactNativeDB[key] = val;
            resolve(key);
          });
        },
        async delete(key) {
          return new Promise(() => {
            delete reactNativeDB[key];
          });
        },
        async keys() {
          return new Promise(resolve => {
            resolve(Object.keys(reactNativeDB));
          });
        }
      }
    });
  }
};

/**
 * Get data from the browser/device storage with IndexedDB
 */
const idbGet = async () => {
  if (!db.idbKeyval) {
    return Promise.resolve(null);
  }
  try {
    // @ts-expect-error TODO: migration from monorepo
    return await db.idbKeyval.get(DB_ITEM);
  } catch {
    // The only time we noticed idb failing it's related
    // to Safari interanl issues https://bugs.webkit.org/show_bug.cgi?id=197050
    config.onError(new Error('IndexedDB:Get:InternalError'));
    return Promise.resolve(null);
  }
};

/**
 * Set data to the browser/device storage with IndexedDB
 */
const idbSet = async data => {
  if (!db.idbKeyval) {
    return;
  }
  try {
    await db.idbKeyval.set(DB_ITEM, data);
  } catch {
    // The only time we noticed idb failing it's related
    // to Safari interanl issues https://bugs.webkit.org/show_bug.cgi?id=197050
    config.onError(new Error('IndexedDB:Set:InternalError'));
  }
};

/* eslint-enable */

/* eslint-disable */

// Legacy Amplitude EventId
const incrementEventId = () => {
  setPersistentData({
    eventId: persistentData.eventId + 1
  });
};

// Legacy Amplitude SequenceNumber
const incrementSequenceNumber = () => {
  setPersistentData({
    sequenceNumber: persistentData.sequenceNumber + 1
  });
};

/**
 * Saves all persistent data to IndexedDB
 */
const savePersistentData = () => {
  if (config.platform === 'server') {
    return;
  }
  setPersistentData({
    // Session definitions
    sessionStart: timeStone.sessionStart,
    // Session definitions
    ac: sessionQuality.ac,
    af: sessionQuality.af,
    ah: sessionQuality.ah,
    al: sessionQuality.al,
    am: sessionQuality.am,
    ar: sessionQuality.ar,
    as: sessionQuality.as,
    pv: sessionQuality.pv
  });
  if (identity.userId) {
    setPersistentData({
      userId: identity.userId
    });
  }
  idbSet(persistentData);
};

/* eslint-disable */

const debugOptions = {
  color: 'rgb(5,177,105)',
  fontSize: 11
};
const debugBatch = options => {
  const metricName = options.metricName,
    data = options.data;
  if (!config.showDebugLogging || !console) {
    return;
  }
  const prefix = `%c ${DEBUG_LOGGING_PREFIX}`;
  const style = `color:${debugOptions.color};font-size:${debugOptions.fontSize}px;`;
  console.group(prefix, style, metricName);
  // @ts-expect-error TODO: migration from monorepo
  data.forEach(event => {
    // @ts-expect-error TODO: migration from monorepo
    if (event.event_type) {
      // @ts-expect-error TODO: migration from monorepo
      console.log(event.event_type, event);
    } else {
      console.log(event);
    }
  });
  console.groupEnd();
};

/**
 * Log an event with metricName and data/duration
 */
const debugLog = options => {
  const metricName = options.metricName,
    data = options.data;
  if (!config.showDebugLogging || !console) {
    return;
  }
  const style = `color:${debugOptions.color};font-size:${debugOptions.fontSize}px;`;
  const prefix = `%c ${DEBUG_LOGGING_PREFIX}`;
  console.log(prefix, style, metricName, data);
};

/* eslint-enable */

/* eslint-disable */

/**
 * Session Start represents the number of milliseconds
 * since epoch (UTC) of when the first event of the session occurs.
 *
 * To persist the sessionStart over time we use IndexedDB.
 * Note: sessionId is a copy of sessionStart and we need to support it
 *       because is part of the Amplitude legacy.
 */
const setSessionStart = () => {
  const now = getNow();
  if (!persistentData.sessionId || !persistentData.lastEventTime || !persistentData.sessionUUID || isSessionEnded(now)) {
    // sessionId is used for legacy Amplitude data
    persistentData.sessionId = now;
    // sessionUUID is the unique identifier used in the Analytics Service
    persistentData.sessionUUID = generateUUID();
    setTime({
      sessionStart: now
    });
    debugLog({
      metricName: `Started new session:`,
      data: {
        persistentData,
        timeStone
      }
    });
  }
  persistentData.lastEventTime = now;
};
const isSessionEnded = now => {
  return now - persistentData.lastEventTime > SESSION_TIMEOUT;
};

/* eslint-disable */

const prepareEventData = logData => {
  // Session data enrichment
  setSessionQualityEnrichment(logData);
  // TODO @zizzamia revist this typing
  const event_type = logData.event_type;
  delete logData.event_type;
  const log_data_device_id = logData.deviceId ? logData.deviceId : null;
  const timestamp = logData.timestamp;
  delete logData.timestamp;
  // Amplitude Legacy enrichment
  incrementEventId();
  incrementSequenceNumber();
  // Session Start enrichment
  setSessionStart();
  // TODO @zizzamia optimize how many times we save the persistent data
  savePersistentData();
  return {
    device_id: identity.deviceId || log_data_device_id || null,
    user_id: identity.userId,
    timestamp,
    event_id: persistentData.eventId,
    session_id: persistentData.sessionId || -1,
    event_type,
    version_name: config.version || null,
    platform: device.amplitudePlatform,
    os_name: device.amplitudeOSName,
    os_version: device.amplitudeOSVersion,
    device_model: device.amplitudeDeviceModel,
    language: identity.languageCode,
    event_properties: _objectSpread(_objectSpread({}, logData), {}, {
      height: device.height,
      width: device.width
    }),
    user_properties: getUserProperties(),
    uuid: generateUUID(),
    library: {
      name: '@cbhq/client-analytics',
      version: ANALYTICS_SDK_VERSION
    },
    sequence_number: persistentData.sequenceNumber,
    user_agent: device.userAgent
  };
};
const prepareEventsData = logsData => {
  return logsData.map(logData => {
    return prepareEventData(logData);
  });
};

/* eslint-disable */

const prepareMetricData = metric => {
  const customTags = metric.tags || {};
  const tags = _objectSpread(_objectSpread({
    authed: getIsAuthed() ? 'true' : 'false',
    platform: config.platform
  }, customTags), {}, {
    project_name: config.projectName,
    version_name: config.version || null
  });
  return {
    metric_name: metric.metricName,
    page_path: metric.pagePath || null,
    value: metric.value,
    tags,
    type: metric.metricType
  };
};
const prepareMetricsData = metrics => {
  return metrics.map(metric => {
    return prepareMetricData(metric);
  });
};

/* eslint-enable */

/* eslint-disable */

/**
 * Returns true if batch events are ready to be sent
 */
const isBatchEventsReady = sendEventsCb => {
  if (scheduler.eventsQueue.length === 0) {
    return false;
  }
  // Check if min threshold met for batch size
  if (scheduler.eventsQueue.length >= config.batchEventsThreshold) {
    return true;
  }
  // Otherwise schedule a sendEvents after batchEventsPeriod,
  // also we make sure we only schedule 1 batch at a time
  if (!scheduler.eventsScheduled) {
    scheduler.eventsScheduled = true;
    setTimeout(() => {
      scheduler.eventsScheduled = false;
      sendEventsCb(prepareEventsData(scheduler.eventsQueue));
      scheduler.eventsQueue = [];
    }, config.batchEventsPeriod);
  }
  // A queueEventsCb was scheduled, no events were sent
  return false;
};

/**
 * Returns true if batch metrics are ready to be sent
 */
const isBatchMetricsReady = sendMetricsCb => {
  if (scheduler.metricsQueue.length === 0) {
    return false;
  }
  // Check if min threshold met for batch size
  if (scheduler.metricsQueue.length >= config.batchMetricsThreshold) {
    return true;
  }
  // Otherwise schedule a sendMetrics after batchMetricsPeriod,
  // also we make sure we only schedule 1 batch at a time
  if (!scheduler.metricsScheduled) {
    scheduler.metricsScheduled = true;
    setTimeout(() => {
      scheduler.metricsScheduled = false;
      sendMetricsCb(prepareMetricsData(scheduler.metricsQueue));
      scheduler.metricsQueue = [];
    }, config.batchMetricsPeriod);
  }
  // A queueMetricsCb was scheduled, no metrics were sent
  return false;
};

/**
 * Returns true if batch metrics are ready to be sent
 */
const isBatchTracesReady = sendTraces => {
  if (scheduler.tracesQueue.length === 0) {
    return false;
  }
  // Check if min threshold met for batch size
  if (scheduler.tracesQueue.length >= config.batchTracesThreshold) {
    return true;
  }
  // Otherwise schedule a sendMetrics after batchMetricsPeriod,
  // also we make sure we only schedule 1 batch at a time
  if (!scheduler.tracesScheduled) {
    scheduler.tracesScheduled = true;
    setTimeout(() => {
      scheduler.tracesScheduled = false;
      sendTraces(scheduler.tracesQueue);
      scheduler.tracesQueue = [];
    }, config.batchTracesPeriod);
  }
  // A queueMetricsCb was scheduled, no metrics were sent
  return false;
};

/**
 * Schedule an event
 * - on web we create a background task with the requestIdleCallback API
 * - on iOS and android we use the InteractionManager to schedule
 *   a task after interactions or animations have completed,
 *   this helps especially animations to run smoothly.
 */
const scheduleEvent = cb => {
  if (isWebPlatform() && window?.requestIdleCallback) {
    window.requestIdleCallback(cb, {
      timeout: config.ricTimeoutScheduleEvent
    });
  } else if ((isAndroidPlatform() || isIOSPlatform()) && config.interactionManager) {
    config.interactionManager.runAfterInteractions(cb);
  } else {
    cb();
  }
};

/* eslint-enable */

/* eslint-disable */

const CONTENT_TYPE_URLENCODED = 'application/x-www-form-urlencoded; charset=UTF-8';
const CONTENT_TYPE_JSON = 'application/json';
const apiFetch = options => {
  const data = options.data,
    importance = options.importance,
    isJSON = options.isJSON,
    onError = options.onError,
    url = options.url;
  const contentType = isJSON ? CONTENT_TYPE_JSON : CONTENT_TYPE_URLENCODED;
  const fetchImportance = importance || AnalyticsEventImportance.low;
  // @ts-expect-error TODO: migration from monorepo
  const body = isJSON ? JSON.stringify(data) : new URLSearchParams(data).toString();
  // For web use sendBeacon when supported
  if (isWebPlatform() && !isJSON && 'sendBeacon' in navigator && fetchImportance === AnalyticsEventImportance.low && (
  // The only header we can set in a beacon is "type"
  // based on https://w3c.github.io/beacon/ docs
  !config.headers || Object.keys(config.headers).length === 0)) {
    const blob = new Blob([body], {
      type: CONTENT_TYPE_URLENCODED
    });
    navigator.sendBeacon(url, blob);
    // Fallback to XHR when sendBeacon is not supported of when we want an high request priority
  } else if (isWebPlatform() && !isJSON) {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    Object.keys(config.headers).forEach(headerName => {
      xhr.setRequestHeader(headerName, config.headers[headerName]);
    });
    xhr.setRequestHeader('Content-Type', CONTENT_TYPE_URLENCODED);
    if (identity.jwt) {
      xhr.setRequestHeader('authorization', `Bearer ${identity.jwt}`);
    }
    xhr.send(body);
    // Everything else use the fetch API
  } else {
    const headers = _objectSpread(_objectSpread({}, config.headers), {}, {
      'Content-Type': contentType
    });
    if (identity.jwt) {
      headers.Authorization = `Bearer ${identity.jwt}`;
    }
    fetch(url, {
      method: 'POST',
      mode: 'no-cors',
      headers,
      body
    }).catch(err => {
      // @ts-expect-error: 2021-03-20: Whitelisted type error. To be corrected after typescript migration.
      onError(err, {
        context: 'AnalyticsSDKApiError'
      });
    });
  }
};

/* eslint-enable */

/* eslint-disable */

const AMPLITUDE_API_VERSION = '2';

/**
 * Because of the wide range of device performance and connectivity,
 * it’s possible for data to become corrupt at any stage during
 * the collection process.
 *
 * The Analytics Service and Amplitude uses a checksum to guarantee
 * that it has not been corrupted in transition.
 */
const getChecksum = (amplitudeApiKey, stringifiedEventData, uploadTime) => {
  const apiKey = amplitudeApiKey || '';
  return md5(AMPLITUDE_API_VERSION + apiKey + stringifiedEventData + uploadTime);
};

/* eslint-enable */

/* eslint-disable */

const isStringNumberOrBoolean = obj => ['string', 'number', 'boolean'].includes(typeof obj);
class CircularJsonReferenceError extends Error {
  constructor(message) {
    super(message);
    this.name = 'CircularJsonReference';
    this.message = message;
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = new Error(message).stack;
    }
  }
}
class DomReferenceInAnalyticsEventError extends CircularJsonReferenceError {
  constructor(...args) {
    super(...args);
    this.name = 'DomReferenceInAnalyticsEvent';
  }
}

/**
 * Attempts to sanitize Amplitude event data that might contain
 * references to a React synthetic event and/or DOM elements
 * before serializing to a JSON string
 */
const safelyJsonStringifyDomEvent = eventData => {
  try {
    const sanitizedEventData = [];
    for (const entry of eventData) {
      const copy = _objectSpread({}, entry);
      if (entry.event_properties) {
        copy.event_properties = _objectSpread(_objectSpread({}, copy.event_properties), {}, {
          currentTarget: null,
          target: null,
          relatedTarget: null,
          _dispatchInstances: null,
          _targetInst: null,
          view: isStringNumberOrBoolean(entry.event_properties.view) ? entry.event_properties.view : null
        });
      }
      sanitizedEventData.push(copy);
    }
    return [true, JSON.stringify(sanitizedEventData)];
  } catch (e) {
    return [false, ''];
  }
};

/* eslint-enable */

/* eslint-disable */

/**
 * All events are fired only after the initial data
 * are retrieved from the IndexedDB. We use a simple queue
 * to store the early events during the initialization time.
 */
const queueEvents = (eventData, eventImportance = AnalyticsEventImportance.low) => {
  if (eventData) {
    // TODO: create a helper to add the event data without using scheduler
    scheduler.eventsQueue.push(eventData);
  }
  if (!db.isReady) {
    return;
  }
  // Ensures events are sent only after the userId is set.
  // This options persist only when trackUserId is true
  if (config.trackUserId && !identity.userId) {
    // Fallback in case the userId was never set when Logged-in
    if (scheduler.eventsQueue.length > MAX_EVENT_DATA_QUEUE_LIMIT) {
      config.trackUserId = false;
      // This should also help discover cases when the identify()
      // method was accidentaly removed or called too late
      config.onError(new Error('userId not set in Logged-in'));
    }
    return;
  }
  // Important to have the EventImportance check before isBatchEventsReady
  // so we don't create extra JS cost when the importance is high
  if (eventImportance === AnalyticsEventImportance.high || isBatchEventsReady(sendEvents)) {
    sendScheduledEvents();
  }
};

/**
 * Send an event to the Analytics Service.
 * This method is called during a browser's idle periods,
 * and updates is in charge to also update the sessionId
 * and sequenceNumber.
 *
 * In case of the user optOut any event will be sent.
 */
const sendEvents = (eventsData, eventImportance = AnalyticsEventImportance.low) => {
  if (identity.isOptOut || eventsData.length === 0) {
    return;
  }
  let stringifiedEventData;
  try {
    stringifiedEventData = JSON.stringify(eventsData);
  } catch (e) {
    // if we encounter a circular reference, keep track of what event triggered it,
    // attempt to flatten the circular dependency and include it on the bugsnag metadata
    const listEventType = eventsData.map(data => data.event_type).join(', ');
    const _safelyJsonStringifyD = safelyJsonStringifyDomEvent(eventsData),
      _safelyJsonStringifyD2 = _slicedToArray(_safelyJsonStringifyD, 2),
      sanitized = _safelyJsonStringifyD2[0],
      result = _safelyJsonStringifyD2[1];

    // if sanitization is not successful then track the error on bugsnag
    // and don't send the events, since we can't serialize
    if (!sanitized) {
      config.onError(new CircularJsonReferenceError(e instanceof Error ? e.message : 'unknown'), {
        listEventType
      });
      return;
    }

    // otherwise, send the event, but still track the error on bugsnag
    // so developers can sanitize at the source
    stringifiedEventData = result;
    config.onError(new DomReferenceInAnalyticsEventError('Found DOM element reference'), {
      listEventType,
      stringifiedEventData
    });
  }
  const uploadTime = getNow().toString();
  // Typical Amplitude event format
  const baseData = {
    e: stringifiedEventData,
    v: AMPLITUDE_API_VERSION,
    upload_time: uploadTime
  };
  const analyticsServiceData = _objectSpread(_objectSpread({}, baseData), {}, {
    client: config.amplitudeApiKey,
    checksum: getChecksum(config.amplitudeApiKey, stringifiedEventData, uploadTime)
  });
  // Request to the Analytics Service
  apiFetch({
    url: config.eventsEndpoint,
    data: analyticsServiceData,
    importance: eventImportance,
    // @ts-expect-error: 2021-03-20: Whitelisted type error. To be corrected after typescript migration.
    onError: config.onError
  });
  debugBatch({
    metricName: `Batch Events`,
    data: eventsData
  });
};

// Prepare events, run light enrichment. send events and reset scheduler
const sendScheduledEvents = () => {
  sendEvents(prepareEventsData(scheduler.eventsQueue));
  setScheduler({
    eventsQueue: []
  });
};

/* eslint-enable */

/* eslint-disable */
const ACTION_OPTIONS = Object.values(ActionType);
const COMPONENT_TYPE_OPTIONS = Object.values(ComponentType);

// TODO @zizzamia not happy with this logic, refactor this code
// with more complex types to eliminate the extra logic
const getActionValue = action => {
  return ACTION_OPTIONS.includes(action) ? action : ActionType.unknown;
};

// TODO @zizzamia not happy with this logic, refactor this code
// with more complex types to eliminate the extra logic
const getComponentTypeValue = componentType => {
  return COMPONENT_TYPE_OPTIONS.includes(componentType) ? componentType : ComponentType.unknown;
};
const getValidatedProperties = (action, componentType, loggingId) => {
  const properties = {
    auth: getIsAuthed() ? AuthStatus.loggedIn : AuthStatus.notLoggedIn,
    action: getActionValue(action),
    component_type: getComponentTypeValue(componentType),
    logging_id: loggingId,
    platform: config.platform,
    project_name: config.projectName
  };
  if (typeof identity.userTypeEnum === 'number') {
    properties.user_type_enum = identity.userTypeEnum;
  }
  return properties;
};
const getValidatedEvent = logData => {
  const timestamp = getNow();
  // This is rare, but our types will not catch empty EventData
  // and cause a JS error. In those cases it's safe the SDK
  // still offers a safe fallback and logs the error.
  if (!logData) {
    config.onError(new Error('missing logData'));
    return _objectSpread(_objectSpread({}, getValidatedProperties(ActionType.unknown, ComponentType.unknown)), {}, {
      locale: identity.locale,
      session_lcc_id: identity.session_lcc_id,
      session_uuid: persistentData.sessionUUID,
      timestamp,
      time_start: timeStone.timeStart
    });
  }
  const validatedEvent = _objectSpread(_objectSpread(_objectSpread({}, logData), getValidatedProperties(logData.action, logData.componentType, logData.loggingId)), {}, {
    locale: identity.locale,
    session_lcc_id: identity.session_lcc_id,
    session_uuid: persistentData.sessionUUID,
    timestamp,
    time_start: timeStone.timeStart
  });
  // When passed componentType or loggingId it's important
  // to removed them from the original reference,
  // and keep only component_type and logging_id
  delete validatedEvent.componentType;
  delete validatedEvent.loggingId;
  return validatedEvent;
};

/* eslint-enable */

const pageview = {
  blacklistRegex: [],
  isEnabled: false
};
function getPageviewProperties() {
  return {
    page_key: location.pageKey,
    page_path: location.pagePath,
    prev_page_key: location.prevPageKey,
    prev_page_path: location.prevPagePath
  };
}
function setPageview(data) {
  Object.assign(pageview, data);
}
function setPageviewEnrichment(validatedEvent) {
  // Page path enrichment
  if (!pageview.isEnabled) {
    return;
  }
  setPagePath();
  Object.assign(validatedEvent, getPageviewProperties());
}

/* eslint-enable */

/**
 * Log an event to the Analytics Service and ultimately stored in Snowflake
 */
function logEvent(eventName, eventData, eventImportance = AnalyticsEventImportance.low) {
  // Stop event if user opt out analytics
  if (identity.isOptOut) {
    return;
  }
  // Stop event if platform is not initialized
  if (!isValidPlatform()) {
    return;
  }

  // Valid properties enrichment
  const validatedEvent = getValidatedEvent(eventData);
  // Pageview and User Attribution enrichment needs to live
  // in logEvent because the pagepath and URL query might change
  // if this enrichment is delayed with any queue system.
  setPageviewEnrichment(validatedEvent);
  setUserAttributionEnrichment(validatedEvent);
  setIdentityFlowEnrichment(validatedEvent);
  // Temporary boolean to help the Analytics Service understand
  // what events we want to send to Amplitude from the Analytics Service
  validatedEvent.has_double_fired = false;
  // Legacy Amplitude event type
  // TODO @zizzamia will be deprecated in 2021
  validatedEvent.event_type = eventName;
  // Adding even an important event into queueEvents is critical because
  // ensure the event gets populated correctly with information
  // stored in the IndexedDB like `sessionStart`, `sessionUUID` and has also
  // the `userId` ready to being used.
  if (eventImportance === AnalyticsEventImportance.high) {
    queueEvents(validatedEvent, eventImportance);
  } else {
    // Schedule event asynchrony based on their best platform APIs
    // e.g. requestIdleCallback, InteractionManager
    scheduleEvent(() => {
      // Add event to a lite queue that focus on waiting
      // db.isReady and identity.userId checks pass
      queueEvents(validatedEvent);
    });
  }
}
function sendMetrics(preparedMetricsData) {
  scheduleEvent(() => {
    apiFetch({
      url: config.metricsEndPoint,
      data: {
        metrics: preparedMetricsData
      },
      isJSON: true,
      // @ts-expect-error: 2021-03-20: Whitelisted type error. To be corrected after typescript migration.
      onError: config.onError
    });
  });
  debugBatch({
    metricName: `Batch Metrics`,
    data: preparedMetricsData
  });
}

/**
 * Log a metric to Datadog Metrics
 */
function logMetric(options) {
  // Stop metric if platform is not valid
  if (!isValidPlatform()) {
    return;
  }
  // Enrich Metric with pagePath, this will allow the Analytics Service
  // to automate the population of page_key as tag
  if (PlatformName.server !== config.platform && !options.pagePath && location.pagePath) {
    // eslint-disable-next-line no-param-reassign
    options.pagePath = location.pagePath;
  }
  const isEmpty = isIdentifyFlowEmpty();
  const tags = !isEmpty ? _objectSpread(_objectSpread({}, options.tags), identityFlow) : options.tags;
  if (tags) {
    Object.assign(options, {
      tags
    });
  }
  scheduler.metricsQueue.push(options);
  if (isBatchMetricsReady(sendMetrics)) {
    const preparedMetricsData = prepareMetricsData(scheduler.metricsQueue);
    sendMetrics(preparedMetricsData);
    scheduler.metricsQueue = [];
  }
}

/* eslint-disable */

let IThresholdTier = /*#__PURE__*/function (IThresholdTier) {
  IThresholdTier["instant"] = "instant";
  IThresholdTier["quick"] = "quick";
  IThresholdTier["moderate"] = "moderate";
  IThresholdTier["slow"] = "slow";
  IThresholdTier["unavoidable"] = "unavoidable";
  return IThresholdTier;
}({});
/**
 * this method converts the web vital metric name onto our datadog name format
 * @param metricName
 */
function getPerformanceMetricName(metricName) {
  return metricName.toLowerCase();
}
const MAX_MEASURE_TIME = 30000;
let networkInformationCached = {};

/**
 * Helper method to define Perfume.js configs and the analyticsTracker
 */
const getPerfumeOptions = () => {
  return {
    analyticsTracker: options => {
      const data = options.data,
        attribution = options.attribution,
        metricName = options.metricName,
        navigatorInformation = options.navigatorInformation,
        rating = options.rating;
      const metric = PERF_EVENTS[metricName];
      const category = attribution?.category || null;
      if (!metric && !category) {
        return;
      }
      // Normalize values for our Data Pipeline
      const deviceMemory = navigatorInformation?.deviceMemory || 0;
      const hardwareConcurrency = navigatorInformation?.hardwareConcurrency || 0;
      const isLowEndDevice = navigatorInformation?.isLowEndDevice || false;
      const isLowEndExperience = navigatorInformation?.isLowEndExperience || false;
      const serviceWorkerStatus = navigatorInformation?.serviceWorkerStatus || 'unsupported';
      // Prepare common properties across most of the events
      const defaultEventData = _objectSpread({
        deviceMemory,
        hardwareConcurrency,
        isLowEndDevice,
        isLowEndExperience,
        serviceWorkerStatus
      }, networkInformationCached);
      // Prepare common DataDog tags across all metrics
      const defaultMetricData = {
        is_low_end_device: isLowEndDevice,
        is_low_end_experience: isLowEndExperience,
        page_key: location.pageKey || '',
        // @ts-expect-error TODO: migration from monorepo
        save_data: data.saveData || false,
        service_worker: serviceWorkerStatus,
        is_perf_metric: true
      };
      // Log event based on the shape of performance metric
      if (metricName === 'navigationTiming') {
        // @ts-expect-error TODO: migration from monorepo
        if (data && typeof data.redirectTime === 'number') {
          logMetric({
            metricName: PERF_EVENTS.redirectTime.eventName,
            metricType: MetricType.histogram,
            tags: defaultMetricData,
            // @ts-expect-error TODO: migration from monorepo
            value: data.redirectTime || 0
          });
        }
      } else if (metricName === 'TTFB') {
        logEvent(metric.eventName, _objectSpread({
          action: ActionType.measurement,
          componentType: ComponentType.page,
          // @ts-expect-error TODO: migration from monorepo
          duration: data || null,
          vitalsScore: rating || null
        }, defaultEventData));
        logMetric({
          metricName: PERF_EVENTS.TTFB.eventName,
          metricType: MetricType.histogram,
          tags: _objectSpread({}, defaultMetricData),
          // @ts-expect-error TODO: migration from monorepo
          value: data
        });
        // Sent to Datadog for real-time metric monitoring
        if (rating) {
          logMetric({
            metricName: `perf_web_vitals_ttfb_${rating}`,
            metricType: MetricType.count,
            tags: defaultMetricData,
            value: 1
          });
        }
      } else if (metricName === 'networkInformation') {
        // @ts-expect-error TODO: migration from monorepo
        if (data?.effectiveType) {
          networkInformationCached = data;
          logEvent(metric.eventName, {
            action: ActionType.measurement,
            componentType: ComponentType.page,
            // @ts-expect-error TODO: migration from monorepo
            networkInformationDownlink: data.downlink,
            // @ts-expect-error TODO: migration from monorepo
            networkInformationEffectiveType: data.effectiveType,
            // @ts-expect-error TODO: migration from monorepo
            networkInformationRtt: data.rtt,
            // @ts-expect-error TODO: migration from monorepo
            networkInformationSaveData: data.saveData,
            navigatorDeviceMemory: deviceMemory,
            navigatorHardwareConcurrency: hardwareConcurrency
          });
        }
      } else if (metricName === 'storageEstimate') {
        logEvent(metric.eventName, _objectSpread(_objectSpread({
          action: ActionType.measurement,
          componentType: ComponentType.page
        }, data), defaultEventData));
        // Sent to Datadog for real-time metric monitoring
        logMetric({
          metricName: 'perf_storage_estimate_caches',
          metricType: MetricType.histogram,
          tags: defaultMetricData,
          // @ts-expect-error TODO: migration from monorepo
          value: data.caches
        });
        logMetric({
          metricName: 'perf_storage_estimate_indexed_db',
          metricType: MetricType.histogram,
          tags: defaultMetricData,
          // @ts-expect-error TODO: migration from monorepo
          value: data.indexedDB
        });
        // Metrics based on score value
      } else if (metricName === 'CLS') {
        logEvent(metric.eventName, _objectSpread({
          action: ActionType.measurement,
          componentType: ComponentType.page,
          // @ts-expect-error TODO: migration from monorepo
          score: data * 100 || null,
          vitalsScore: rating || null
        }, defaultEventData));
        // Sent to Datadog for real-time metric monitoring
        if (rating) {
          logMetric({
            metricName: `perf_web_vitals_cls_${rating}`,
            metricType: MetricType.count,
            tags: defaultMetricData,
            value: 1
          });
        }
        // Metrics with extra eventProperties
      } else if (metricName === 'FID') {
        const entry = attribution?.performanceEntry || null;
        const parsedProcessingStart = parseInt(entry?.processingStart || '');
        logEvent(metric.eventName, _objectSpread({
          action: ActionType.measurement,
          componentType: ComponentType.page,
          // @ts-expect-error TODO: migration from monorepo
          duration: data || null,
          processingStart: entry?.processingStart ? parsedProcessingStart : null,
          startTime: entry?.startTime ? parseInt(entry.startTime) : null,
          vitalsScore: rating || null
        }, defaultEventData));
        // Sent to Datadog for real-time metric monitoring
        if (rating) {
          logMetric({
            metricName: `perf_web_vitals_fidVitals_${rating}`,
            metricType: MetricType.count,
            tags: defaultMetricData,
            value: 1
          });
        }
        // logging user journey step
      } else if (metricName === 'userJourneyStep') {
        logEvent('perf_user_journey_step', _objectSpread({
          action: ActionType.measurement,
          componentType: ComponentType.page,
          // @ts-expect-error
          duration: data || null,
          rating: rating ?? null,
          step_name: attribution?.stepName || ''
        }, defaultEventData));
        logMetric({
          metricName: `user_journey_step.${config.projectName}.${config.platform}.${attribution?.stepName || ''}_vitals_${rating}`,
          metricType: MetricType.count,
          tags: defaultMetricData,
          value: 1
        });
        logMetric({
          metricName: `user_journey_step.${config.projectName}.${config.platform}.${attribution?.stepName || ''}`,
          metricType: MetricType.distribution,
          tags: defaultMetricData,
          // @ts-expect-error
          value: data || null
        });
        // Metrics based on duration value
      } else if (PERF_EVENTS[metricName]) {
        logEvent(metric.eventName, _objectSpread({
          action: ActionType.measurement,
          componentType: ComponentType.page,
          // @ts-expect-error TODO: migration from monorepo
          duration: data || null,
          vitalsScore: rating || null
        }, defaultEventData));
        // Sent to Datadog for real-time metric monitoring
        if (rating) {
          logMetric({
            metricName: `perf_web_vitals_${getPerformanceMetricName(metricName)}_${rating}`,
            metricType: MetricType.count,
            tags: defaultMetricData,
            value: 1
          });
        }
      }
    },
    maxMeasureTime: MAX_MEASURE_TIME,
    steps: config.steps,
    onMarkStep: onMarkStepOptions
  };
};
const onMarkStepOptions = (mark, steps) => {
  if (config?.onMarkStep) {
    config.onMarkStep(mark, steps);
  }
  identifyFlow({
    ujs: steps
  });
};

// @ts-expect-error missing perfume.js type
let perfumeInstance;
const perfume = {
  Perfume: () => {},
  markStep: step => {},
  markStepOnce: step => {},
  incrementUjNavigation: () => {}
};

/**
 * markNTBT is used to initiate Navigation Total Blocking Time from perfume.js
 */
const markNTBT = () => {
  // This method will be defined only if we are in web
  if (isWebPlatform() && perfumeInstance && perfumeInstance.markNTBT) {
    perfumeInstance.markNTBT();
  }
};

/**
 *  markStep is used to mark a point in the application where a user journey step can begin or end
 */
const markStep = step => {
  if (isWebPlatform() && perfumeInstance && perfume.markStep) {
    perfume.markStep(step);
  }
};

/**
 * markStepOnce is used to mark a point in the application once per session
 * where a user journey step can begin or end only
 * */
const markStepOnce = step => {
  if (isWebPlatform() && perfumeInstance && perfume.markStepOnce) {
    perfume.markStepOnce(step);
  }
};

/**
 * incrementUjNavigation is used to track navigational changes in an application,
 * this helps ensure there are only active user journey steps
 * */
const incrementUjNavigation = () => {
  if (isWebPlatform() && perfumeInstance && perfume.incrementUjNavigation) {
    perfume.incrementUjNavigation();
  }
};

/**
 * Initiate field data for performance metrics
 * Docs: https://github.com/Zizzamia/perfume.js
 */
const initPerfMonitoring = () => {
  if (isWebPlatform()) {
    try {
      const perfumeLib = require('perfume.js');
      perfume.markStep = perfumeLib.markStep;
      perfume.markStepOnce = perfumeLib.markStepOnce;
      perfume.incrementUjNavigation = perfumeLib.incrementUjNavigation;
      perfumeInstance = new perfumeLib.Perfume(getPerfumeOptions());
    } catch (e) {
      if (e instanceof Error) {
        config.onError(e);
      }
    }
  }
};

/* eslint-enable */

/**
 * Public method to manually track a pageview
 */

function logPageView(options = {
  callMarkNTBT: true
}) {
  // Stop log if platform is not initialized
  if (config.platform === 'unknown') {
    return;
  }
  // Avoid pageview for blacklist pathnames
  if (pageview.blacklistRegex.some(r => r.test(getUrlPathname()))) {
    return;
  }
  logEvent(PAGEVIEW_EVENT_TYPE, {
    action: ActionType.render,
    componentType: ComponentType.page
  });
  if (options.callMarkNTBT) {
    markNTBT();
  }
}

/* eslint-disable */

/**
 * Simple Resize listener to detect viewport resize.
 * Instead of Trottle we use requestAnimationFrame to avoid blocking the CPU
 * and help guarantee smooth changes or animations.
 */
const onResizeWithRAF = cb => {
  addEventListener('resize', () => {
    requestAnimationFrame(() => {
      cb();
    });
  });
};

/* eslint-enable */

/* eslint-disable */

let isUnloading = false;
let listenersAdded = false;
const onPageHide = event => {
  isUnloading = !event.persisted;
};
const addListeners = () => {
  // The pagehide event is sent to a Window when the browser hides
  // the current page in the process of presenting a different page
  // from the session's history. For example, when the user clicks
  // the browser's Back button, the current page receives a pagehide event
  // before the previous page is shown.
  addEventListener('pagehide', onPageHide);

  // The beforeunload event is fired when the window, the document and
  // its resources are about to be unloaded.
  // The document is still visible and the event is still cancelable at this point.
  //
  // `beforeunload` is needed to fix this bug:
  // https://bugs.chromium.org/p/chromium/issues/detail?id=987409

  addEventListener('beforeunload', () => {});
};
const onVisibilityChange = (cb, visibilityState = 'hidden', once = false) => {
  if (!listenersAdded) {
    addListeners();
    listenersAdded = true;
  }
  addEventListener('visibilitychange', ({
    timeStamp
  }) => {
    if (document.visibilityState === visibilityState) {
      cb({
        timeStamp,
        isUnloading
      });
    }
  }, {
    capture: true,
    once
  });
};

/* eslint-enable */

/* eslint-disable */
/* eslint-enable */

function clearUAAData() {
  UAA_QUERIES.forEach(key => {
    if (persistentData[key]) {
      delete persistentData[key];
    }
  });
  savePersistentData();
}
const MAX_SESSION_IN_SECONDS = 36000; // 10 Hours

function recordSessionDuration() {
  const sessionHasEnded = isSessionEnded(getNow());
  if (sessionHasEnded) {
    clearUAAData();
  }
  if (!persistentData.lastEventTime || !timeStone.sessionStart || !sessionHasEnded) {
    return;
  }
  const sessionDuration = Math.round((persistentData.lastEventTime - timeStone.sessionStart) / 1000);
  // Remove false negative/positive data
  if (sessionDuration < 1 || sessionDuration > MAX_SESSION_IN_SECONDS) {
    return;
  }
  const sessionRank = getSessionRank(sessionDuration);
  logEvent(SESSIONS_DURATION_EVENT_TYPE, {
    action: ActionType.measurement,
    componentType: ComponentType.page,
    session_duration: sessionDuration,
    session_end: persistentData.lastEventTime,
    session_start: timeStone.sessionStart,
    session_rank: sessionRank
  });
}

/**
 * Initialization of all methods that need to be executed
 * when the page visibility changes to hidden or visible.
 *
 * Note: for now we have only web events, but we eventually
 * should have React Native visibility events as well.
 */
function initPageVisibilityChange() {
  if (isWebPlatform()) {
    onVisibilityChange(() => {
      setPersistentData({
        lastEventTime: getNow()
      });
      savePersistentData();
      sendScheduledEvents();
    }, 'hidden');
    onVisibilityChange(() => {
      recordSessionDuration();
    }, 'visible');
  }
}

/**
 * Initialization of all methods that need to be executed
 * when the page change viewport size.
 */
function initPageResize() {
  if (isWebPlatform()) {
    onResizeWithRAF(() => {
      setPlatform();
      setDeviceSize({
        width: window?.innerWidth ?? null,
        height: window?.innerHeight ?? null
      });
    });
  }
}

/* eslint-disable */

const cbDBInit = [];
const cbDBReady = [];
const initByDB = async () => {
  const db = await idbGet();
  setDB({
    isReady: true
  });
  onDBInit();
  if (!db) {
    return;
  }
  onDBReady();
  setPersistentData({
    // Legacy Amplitude
    eventId: db.eventId || persistentData.eventId,
    sequenceNumber: db.sequenceNumber || persistentData.sequenceNumber,
    sessionId: db.sessionId || persistentData.sessionId,
    // Session definitions
    lastEventTime: db.lastEventTime || persistentData.lastEventTime,
    sessionUUID: db.sessionUUID || persistentData.sessionUUID
  });
  setUAAValues(db);
  setTime({
    sessionStart: db.sessionStart || persistentData.sessionStart
  });
  setSessionQuality({
    ac: db.ac || sessionQuality.ac,
    af: db.af || sessionQuality.af,
    ah: db.ah || sessionQuality.ah,
    al: db.al || sessionQuality.al,
    am: db.am || sessionQuality.am,
    ar: db.ar || sessionQuality.ar,
    as: db.as || sessionQuality.as,
    pv: db.pv || sessionQuality.pv
  });
  if (config.trackUserId) {
    setIdentity({
      userId: db.userId || identity.userId
    });
  }
  // Make sure to record the session_duration just after we read
  // the value of sessionStart, lastEventTime and session actions from IndexedDB
  // Note: we need to run this method just before a new session will start,
  //       that's why is critical to execute it inside initByDB just after we
  //       collected past data and just before we enrich all new log events data.
  recordSessionDuration();
  debugLog({
    metricName: `Initialized Analytics IndexedDB:`,
    data: db
  });
};

/**
 * The Database is initiliazed and it executes
 * all the queued callbacks
 */
const onDBInit = () => {
  const cb = cbDBInit.shift();
  if (cb) {
    cb();
  }
};

/**
 * The Database is ready to be used and it executes
 * all the queued callbacks.
 *
 * The key difference between Init and Ready is that
 * some browser have not IndexedDB support, and they
 * might never be ready. Where instead Init is simply
 * refers that the Database logic was initialized.
 */
const onDBReady = () => {
  const cb = cbDBReady.shift();
  if (cb) {
    cb();
  }
};

/* eslint-enable */

// Return current UAA data stored in IndexedDB
function dbUAAData(db) {
  const uaaDataInDB = {};
  UAA_QUERIES.forEach(key => {
    if (db[key]) {
      uaaDataInDB[key] = db[key];
    }
  });
  return uaaDataInDB;
}

/**
 * Create allowed User Acquisition Attribution from queries
 */
function setUAAValues(db) {
  setPersistentData(_objectSpread(_objectSpread({}, dbUAAData(db)), uaaValuesFromUrl()));
}

/* eslint-disable */

/**
 * Initializes the Amplitude Lite SDK with
 * the apiKey and any optional configurations.
 *
 * This is required before any other methods can be called.
 */
const init = analyticsConfig => {
  setConfig(analyticsConfig);
  setLanguageCode();
  setPlatform();
  // Init IndexedDB after the platform is defined
  initIDB();
  debugLog({
    metricName: `Initialized Analytics:`,
    data: {
      deviceId: identity.deviceId
    }
  });
  cbDBInit.push(() => {
    // Run queueEvents as soon as the DB is ready, this covers an edge case
    // in Safari where the first event is not fired until there is a second one
    // TODO @zizzamia re-test this logic to see possible improvements
    queueEvents();
  });
  initByDB();
  setDevice();
  initPageVisibilityChange();
  initPageResize();
  initPerfMonitoring();
};
const getExperimentExposureParams = experimentData => {
  return {
    test_name: experimentData.testName,
    group_name: experimentData.group,
    subject_id: experimentData.subjectId,
    exposed_at: getNow(),
    subject_type: experimentData.subjectType,
    platform: config.platform
  };
};

/**
 * This method fires an exposure event to the Analytics Service
 */
const exposeExperiment = experimentData => {
  const data = getExperimentExposureParams(experimentData);
  apiFetch({
    url: config.exposureEndpoint,
    // @ts-expect-error TODO: migration from monorepo
    data: [data],
    // @ts-expect-error: 2021-03-20: Whitelisted type error. To be corrected after typescript migration.
    onError: config.onError,
    isJSON: true,
    // Exposures should be fired with high priority to avoid imbalances caused
    // by differing queueing delays (requestIdleCallback) across experiment
    // groups.
    importance: AnalyticsEventImportance.high
  });
  debugLog({
    metricName: `Event: exposeExperiment`,
    data
  });
};

/**
 * Sets the User ID and updates user properties for future events.
 */
const identify = properties => {
  setIdentity(properties);
  debugLog({
    metricName: `Identify:`,
    data: {
      countryCode: identity.countryCode,
      deviceId: identity.deviceId,
      userId: identity.userId
    }
  });
};

/**
 * Initiate auto instrumentation for the `pageview` events.
 */
const initTrackPageview = ({
  blacklistRegex,
  pageKeyRegex,
  browserHistory
}) => {
  setPageview({
    blacklistRegex: blacklistRegex || [],
    isEnabled: true
  });
  setLocation({
    pageKeyRegex
  });
  logPageView({
    callMarkNTBT: false
  });
  browserHistory.listen(() => {
    logPageView();
  });
};

/**
 * For Next.js apps, initiate auto instrumentation for the `pageview` events.
 */
const initNextJsTrackPageview = ({
  blacklistRegex,
  pageKeyRegex,
  nextJsRouter
}) => {
  setPageview({
    blacklistRegex: blacklistRegex || [],
    isEnabled: true
  });
  setLocation({
    pageKeyRegex
  });
  logPageView({
    callMarkNTBT: false
  });
  const nextJsLogPageView = () => {
    logPageView();
  };
  nextJsRouter.events.on('routeChangeComplete', nextJsLogPageView);
};
/**
 * Turns off logging for the user.
 * No events will be saved or sent to Analytics Service
 * while this is enabled.
 */
const optOut = () => {
  setIdentity({
    isOptOut: true
  });
  idbSet({});
};

/**
 * Turns on logging for the user.
 */
const optIn = () => {
  setIdentity({
    isOptOut: false
  });
};

/* eslint-enable */

const automatedEvents = {
  Button: {
    label: 'cb_button',
    uuid: 'e921a074-40e6-4371-8700-134d5cd633e6',
    componentType: ComponentType.button
  }
};

/**
 * This method helps to create a custom event config to use with a CDS component
 * @param componentName event name to track
 * @param actions list of actions to track, e.g. click, hover
 * @param data custom data for the event
 */
function createEventConfig(componentName, actions, data) {
  return {
    componentName,
    actions,
    data
  };
}
function automatedLogEvent(event, action, config) {
  const componentName = config.componentName,
    data = config.data;
  logEvent(event.label, _objectSpread({
    componentType: event.componentType,
    action,
    loggingId: event.uuid,
    component_name: componentName
  }, data));
}

/**
 * This mapping enables the integration with CDS Event Handler: https://cds.cbhq.net/analytics/.
 * This map contains (will contain) an entry for each of the CDS components and their respective actions.
 * For each action we define a callback that will be used by CDS EventHandlerCallback to pass component information
 * and track said information by using automatedLogEvent.
 * For each component developers can define actionMapping entries to convert CDS
 * actions to Client Analytics ones.
 */
const automatedMappingConfig = {
  actionMapping: {
    onPress: ActionType.click,
    onHover: ActionType.hover
  },
  handlers: {
    Button: {
      [ActionType.click]: customConfig => automatedLogEvent(automatedEvents.Button, ActionType.click, customConfig),
      [ActionType.hover]: customConfig => automatedLogEvent(automatedEvents.Button, ActionType.hover, customConfig)
    }
  }
};
function sendTraces(traces) {
  scheduleEvent(() => {
    apiFetch({
      url: config.tracesEndpoint,
      data: {
        traces
      },
      isJSON: true,
      // @ts-expect-error: 2021-03-20: Whitelisted type error. To be corrected after typescript migration.
      onError: config.onError
    });
  });
  debugBatch({
    metricName: `Batch Traces`,
    data: traces
  });
}
const MILLI_TO_NANO_CONVERSION_RATE = 1_000_000;
/**
 * converts milliseconds to nanoseconds (required by tracing)
 * @param milliseconds
 */
function millisecondsToNanoseconds(milliseconds) {
  return milliseconds * MILLI_TO_NANO_CONVERSION_RATE;
}

/**
 * returns crypto library from  the window object
 */
function getCrypto() {
  return window?.crypto;
}

/**
 * generates a unique tracing id (unsigned int 64) as a string
 * to keep precision
 * if this method is called on react native or server environment
 * you need to pass an implementation fo the Crypto object
 *
 * @param crypto
 */
function getTracingId(crypto = getCrypto()) {
  const array = new Uint32Array(2);
  crypto?.getRandomValues(array);
  // eslint-disable-next-line no-bitwise
  const uint64 = (BigInt(array[0]) << BigInt(32)) + BigInt(array[1]);
  return uint64.toString();
}

/**
 * returns a object containing tracing headers and their value
 * using the trace and span IDs passed as params
 * @param traceId
 * @param spanId
 */
function getTracingHeaders(traceId, spanId) {
  return {
    'x-datadog-origin': 'rum',
    'x-datadog-parent-id': spanId,
    'x-datadog-sampling-priority': '1',
    'x-datadog-trace-id': traceId
  };
}

/**
 *
 * @param spanInit
 * @param.start The start time of the request in _millisenconds_ from the UNIX epoch.
 * @param.duration The duration of the request in _millisenconds_.
 */
function createNewSpan(spanInit) {
  const name = spanInit.name,
    traceId = spanInit.traceId,
    spanId = spanInit.spanId,
    start = spanInit.start,
    duration = spanInit.duration,
    resource = spanInit.resource,
    meta = spanInit.meta;
  return {
    duration: duration ? millisecondsToNanoseconds(duration) : 0,
    name,
    resource,
    service: config.projectName,
    span_id: spanId ?? getTracingId(),
    start: start ? millisecondsToNanoseconds(start) : 0,
    trace_id: traceId ?? getTracingId(),
    // this is a default value
    parent_id: DEFAULT_SPAN_PARENT_ID,
    type: DEFAULT_SPAN_TYPE,
    meta: _objectSpread(_objectSpread(_objectSpread({
      platform: config.platform
    }, location.pageKey ? {
      page_key: location.pageKey
    } : {}), identityFlow.ujs?.length ? {
      last_ujs: identityFlow.ujs[identityFlow.ujs.length - 1]
    } : {}), meta ?? {})
  };
}

/**
 *
 * Updates the original span
 * @param span the span you want to update
 * @param options
 * @param.start The start time of the request in _millisenconds_ from the UNIX epoch.
 * @param.duration The duration of the request in _millisenconds_.
 *
 */
function updateSpan(span, options) {
  const meta = _objectSpread(_objectSpread({}, span.meta), options.meta);
  const times = {
    start: options.start ? millisecondsToNanoseconds(options.start) : span.start,
    duration: options.duration ? millisecondsToNanoseconds(options.duration) : span.duration
  };
  Object.assign(span, options, _objectSpread({
    meta
  }, times));
}

/**
 * returns true if the trace has at least one span otherwise false
 */
function isValidTrace(trace) {
  return trace.length > 0;
}

/**
 * this methods updates each single span in the trace with the passed options
 */
function updateTrace(trace, options) {
  trace.forEach(span => updateSpan(span, options));
}

/**
 * Creates a new trace containing a single span initiated with the
 * spanOptions
 * @param spanOptions
 */
function createNewTrace(spanOptions) {
  return [createNewSpan(spanOptions)];
}
function logTrace(trace, options) {
  // Stop trace if platform is not initialized
  if (!isValidPlatform()) {
    return;
  }
  if (!isValidTrace(trace)) {
    return;
  }
  if (options) {
    // update only if options are passed in
    updateTrace(trace, options);
  }
  scheduler.tracesQueue.push(trace);
  if (isBatchTracesReady(sendTraces)) {
    sendTraces(scheduler.tracesQueue);
    scheduler.tracesQueue = [];
  }
}
function isWindowSupported() {
  return typeof window !== undefined;
}
function measure(markLabel, markStartStep, markStep) {
  try {
    performance.measure(markLabel, markStartStep, markStep);
  } catch (error) {
    config.onError(error);
  }
}
function isPerformanceTrackingSupported() {
  return isWindowSupported() && 'performance' in window && 'mark' in performance && 'getEntriesByName' in performance;
}
function getMarkLabel(markName, options) {
  return `perf_${markName}${options?.label ? `_${options.label}` : ''}`;
}
function getMarkStep(markName, step, options) {
  return `${getMarkLabel(markName, options)}__${step}`;
}
let perfMarkStatus = {};
function perfMark(markName, step, options) {
  if (!isPerformanceTrackingSupported()) {
    return;
  }
  const markStep = getMarkStep(markName, step, options);
  performance.mark(markStep);
  if (step === 'end') {
    const markLabel = getMarkLabel(markName, options);
    const markStartStep = getMarkStep(markName, 'start', options);
    measure(markLabel, markStartStep, markStep);
    const entry = performance.getEntriesByName(markLabel).pop();
    if (entry) {
      logMetric(_objectSpread({
        metricName: markName,
        metricType: MetricType.distribution,
        value: entry.duration
      }, options?.tags ? {
        tags: options.tags
      } : {}));
    }
  }
}
function startPerfMark(markName, options) {
  if (!isPerformanceTrackingSupported()) {
    return;
  }
  const markStep = getMarkStep(markName, 'start', options);
  // check if mark start exist first
  if (!perfMarkStatus[markStep]) {
    perfMark(markName, 'start', options);
    perfMarkStatus[markStep] = true;
  }
}
function clearMarkEntry(markName, options) {
  const markStartStep = getMarkStep(markName, 'start', options);
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const _perfMarkStatus = perfMarkStatus,
    _ = _perfMarkStatus[markStartStep],
    otherMarks = _objectWithoutProperties(_perfMarkStatus, [markStartStep].map(_toPropertyKey));
  perfMarkStatus = otherMarks;
}
function endPerfMark(markName, options) {
  if (!isPerformanceTrackingSupported()) {
    return;
  }
  const markStartStep = getMarkStep(markName, 'start', options);
  // check if mark start exist first
  if (perfMarkStatus[markStartStep]) {
    // check if we already called end mark
    perfMark(markName, 'end', options);
    clearMarkEntry(markName, options);
  }
}
function clearPerformanceMarkEntries() {
  if (!isPerformanceTrackingSupported()) {
    return;
  }
  performance.clearMarks();
  perfMarkStatus = {};
}

/**
 * A function that returns a callback to be used when tracking an event
 */
function useEventLogger(name, properties, eventImportance = AnalyticsEventImportance.low) {
  const propertiesRef = useRef(properties);
  useEffect(() => {
    propertiesRef.current = properties;
  }, [properties]);
  return useCallback(customProperties => {
    logEvent(name, _objectSpread(_objectSpread({}, propertiesRef.current), customProperties), eventImportance);
  }, [name, eventImportance]);
}

/**
 * A function that tracks an event when a component mounts.
 */
function useLogEventOnMount(name, properties) {
  useEffect(() => {
    const validProperties = _objectSpread(_objectSpread({}, properties), {}, {
      action: ActionType.render
    });
    logEvent(name, validProperties);
    // eslint-disable-next-line
  }, []);
}

/**
 * It will return two callbacks used to start and end marks.
 * `Options` can be passed when calling the custom hook and/or
 * overridden by passing options to `markEndPerf`
 * @param markName suffix used by the browser to generate mark timing entries
 * @param options to customize browser timing entry and logMetric call
 */
function usePerformanceMarks(markName, options) {
  const markStartPerf = useCallback(() => startPerfMark(markName, options), [markName, options]);
  const markEndPerf = useCallback(newOptions => endPerfMark(markName, _objectSpread(_objectSpread({}, options), newOptions)), [markName, options]);
  return {
    markStartPerf,
    markEndPerf
  };
}

/**
 * this method checks if a property is valid (no undefined, no null, no empty string)
 * @param property
 */
function isPropertyValid(property) {
  return property !== undefined && property !== null && property !== '';
}

/**
 * this methods return the content of identity
 */
function getUserContext() {
  return Object.entries(_objectSpread(_objectSpread(_objectSpread({}, identityFlow), getPageviewProperties()), {}, {
    sessionUUID: persistentData.sessionUUID,
    userId: persistentData.userId
  })).reduce((acc, entry) => {
    return isPropertyValid(entry[1]) ? _objectSpread(_objectSpread({}, acc), {}, {
      [entry[0]]: entry[1]
    }) : acc;
  }, {});
}

/* eslint-disable */
function escapeHeaderArray(list) {
  if (list === undefined || list.length === 0) return '';
  return list.join(',');
}
function getAnalyticsHeaders() {
  return {
    'X-CB-Device-ID': identity.deviceId || 'unknown',
    'X-CB-Is-Logged-In': identity.userId ? 'true' : 'false',
    'X-CB-Pagekey': location.pageKey || 'unknown',
    'X-CB-UJS': escapeHeaderArray(identityFlow.ujs),
    'X-CB-Platform': config.platform || 'unknown',
    'X-CB-Project-Name': config.projectName || 'unknown',
    'X-CB-Session-UUID': persistentData.sessionUUID || 'unknown',
    'X-CB-Version-Name': config.version ? String(config.version) : 'unknown'
  };
}

/* eslint-enable */

export { ActionType, AmplitudePlatformName, AnalyticsEventImportance, AnalyticsQueries, AuthStatus, ComponentType, IThresholdTier, MetricType, PlatformName, SessionActions, SessionAutomatedEvents, SessionRank, SubjectType, UserTypeCommerce, UserTypeInsto, UserTypeRetail, UserTypeRetailBusinessBanking, UserTypeRetailEmployeeInternal, UserTypeRetailEmployeePersonal, UserTypeWallet, automatedEvents, automatedMappingConfig, clearMarkEntry, clearPerformanceMarkEntries, config, createEventConfig, createNewSpan, createNewTrace, device, endPerfMark, exposeExperiment, generateUUID, getAnalyticsHeaders, getReferrerData, getTracingHeaders, getTracingId, getUrlHostname, getUrlParams, getUrlPathname, getUserContext, identify, identifyFlow, identity, identityFlow, incrementUjNavigation, init, initNextJsTrackPageview, initTrackPageview, isEventKeyFormatValid, isSessionEnded, location, logEvent, logMetric, logPageView, logTrace, markNTBT, markStep, markStepOnce, onVisibilityChange, optIn, optOut, perfMark, persistentData, postMessage, recordSessionDuration, removeFromIdentifyFlow, savePersistentData, sendScheduledEvents, setBreadcrumbs, setConfig, setLocation, setPagePath, setPageview, setPersistentData, setSessionStart, setTime, startPerfMark, timeStone, useEventLogger, useLogEventOnMount, usePerformanceMarks };
//# sourceMappingURL=index.js.map
